import axios from "axios";
import { baseUrl, portal } from "../App";
import { EVENT_ID } from "../assets/constant";
export const transformLeaderboardData = (data) => {
  return {
    User_Rank: data.user_rank || 1,
    msisdn: data.msisdn || "",
    time_taken: data.total_time || 0,
    avatar_id: data.avatar_id || 1, // Default avatar ID
    avatar_img: data.avatar_img || "" // Empty avatar image
  };
};
export const fetchLeaderboardForIndividual = async (leaderboardName,token,playerData) => {
  if(!leaderboardName || !token) return {};
  if(leaderboardName === 'leaderboard_wordly_bangla' || leaderboardName === 'leaderboard_wordly_english' || leaderboardName === 'leaderboard_spelling'){
    const res = await axios.get(`${baseUrl}/api/participantProfile/user_leaderboard/?portal=${portal}`, {
      headers: { Authorization: `Token ${token}` }
    });
    let userLeaderboard = res?.data?.leaderboard ?? [];
    let activeUserLeaderboard = leaderboardName === 'leaderboard_wordly_bangla' ? EVENT_ID.WORDLY_BANGLA_EVENT : leaderboardName === 'leaderboard_wordly_english' ? EVENT_ID.WORDLY_ENGLISH_EVENT : leaderboardName === 'leaderboard_spelling' ? EVENT_ID.SPELLING_BEE_EVENT : leaderboardName === 'leaderboard_memory_e' ? EVENT_ID.MEMORY_MATCH_EVENT : leaderboardName === 'leaderboard_memory_m' ? EVENT_ID.MEMORY_MATCH_EVENT : leaderboardName === 'leaderboard_memory_h' ? EVENT_ID.MEMORY_MATCH_EVENT : '';
    const currentUserBoardData = userLeaderboard?.find(item => item.event_id === activeUserLeaderboard) || {};
    return currentUserBoardData;
  }else if(leaderboardName === 'leaderboard_memory_e' || leaderboardName === 'leaderboard_memory_m' || leaderboardName === 'leaderboard_memory_h'){
    let difficulty = '';
    if (leaderboardName === 'leaderboard_memory_e') {
      difficulty = 'easy';
    } else if (leaderboardName === 'leaderboard_memory_m') {
      difficulty = 'medium';
    } else if (leaderboardName === 'leaderboard_memory_h') {
      difficulty = 'hard';
    }
    const res = await axios.get(`${baseUrl}/api/participantProfile/user_leaderboard/?event_id=151&difficulty=${difficulty}`, {
      headers: { Authorization: `Token ${token}` }
    });
    let memoryMatchLeaderboard = res?.data?.memorymatch_leaderboard ?? [];
    const filteredLeaderboard = memoryMatchLeaderboard.filter(item => item.difficulty_level === difficulty);
    return filteredLeaderboard.length > 0 ? transformLeaderboardData(filteredLeaderboard[0]) : {};
  }
  else{
    return {};
  }
}